import { createClient } from '@supabase/supabase-js';

// Coloque suas chaves diretamente aqui entre as aspas.
// Isso garante que o site funcione independentemente das configurações do Cloudflare.
const supabaseUrl = 'https://ktultuqlwawwwsjlvsdd.supabase.co';
const supabaseKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Imt0dWx0dXFsd2F3d3dzamx2c2RkIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzYwOTk2MTAsImV4cCI6MjA5MTY3NTYxMH0.6YrhLU8ru-9v_NqAuQ6QPrpQ95xc414E3jEumtJ45Wg';

// Verificação simples para te ajudar no console
if (supabaseUrl.includes('SUA_URL')) {
  console.warn('⚠️ Alerta: Você precisa colar a URL e a KEY reais do seu painel do Supabase!');
}

export const supabase = createClient(supabaseUrl, supabaseKey);
